const PromotionTypeEnum = Object.freeze({
  CUPOM: 'CUPOM',
  CAMPANHA: 'CAMPANHA',
});

export default PromotionTypeEnum;
